<template>
  <div class="feedbackResult-box">
    <div>
      <div class="add">
        <p class="title">督办要求</p>
        <van-field
              class="textarea"
              v-model="content"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入"
            />
        <!-- <textarea
          v-model="content"
          class="textarea"
          placeholder="请输入"
          cols="30"
          rows="10"
          maxlength="500"
        ></textarea> -->
        <div class="tip">{{ content.length }}/500</div>
      </div>
      <div class="upload-box">
        <p class="title">上传附件</p>
        <upload class="upload" @fileuploadData="fileUploadData" :fileBizType="70"></upload>
      </div>
    </div>
    <div class="btn" :class="{'disable': !content}" @click="onSubmit">确定</div>
  </div>
</template>

<script>
import upload from "../components/upload";
import api from "@/service/modules/refund.js";

export default {
  components: { upload },
  data() {
    return {
      content: "",
      fileList: [], // 上传文件列表
      Imglist: [],
      data: {}, // 退货单详情
      userInfo: {}
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("refundUserInfo"));
    this.data = this.$route.query.data;
  },
  methods: {
     fileUploadData(val) {
      this.Imglist = val
    },
    // 提交
    onSubmit() {
      try {
        if (!this.content) {
          return this.$Toast({
            message: "请先填写督办要求"
          });
        }
        let img = this.Imglist.join(",");
        const param = {
          content: this.content,
          refundOrderId: this.data.basicId,
          attachId: img,
          attachIds: ""
        };
        api.supervise(param).then(res => {
          if (res.ret === 0) {
            this.$Toast({
              message: "添加督办成功"
            });
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          } else {
            this.$Toast({
              message: res.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 删除预览图片
    delPreImg() {
      // 没有图片是filelist是空，有内容时是一个对象
    }
  }
};
</script>
<style lang="less" scoped>
.feedbackResult-box {
  padding: 0 16px;
  padding-top: 30px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 34px;
  .cell-list {
    margin-bottom: 24px;
    .cell {
      padding: 24px 0;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .label {
        font-size: 14px;
        color: #666666;
        span {
          color: red;
          vertical-align: middle;
          margin-left: 2px;
        }
      }
      /deep/.content {
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
        }
        span {
          font-size: 14px;
          color: #171a1d;
        }
        .arrow {
          font-size: 16px;
          vertical-align: sub;
          margin-left: 5px;
        }
      }
      .money-box {
        display: flex;
        align-items: center;
        .van-cell {
          max-width: 90px;
          padding-left: 5px;
        }
      }
    }
  }
  .add {
    position: relative;
    margin-bottom: 24px;
    .title {
      font-size: 16px;
      color: #1E2226;
      margin-bottom: 12px;
      &::after {
        content: "*";
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F94F4E;
        margin-left: 5px;
      }
    }
    /deep/.textarea {
      width: 100%;
      background: #f8f9fb;
      padding: 16px 4px 16px 16px;
      border-radius: 4px;
      border: 0;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      .van-field__control {
        min-height: 120px;
        max-height: 320px;
      }
        .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
    }

    textarea::-webkit-input-placeholder {
          /* WebKit browsers */
          /* placeholder颜色  */
          color: #9DA0A4;
        }
        textarea:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #9DA0A4;
        }
        textarea::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #9DA0A4;
        }
        textarea::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #9DA0A4;
        }
    .tip {
      text-align: right;
      padding-right: 16px;
      background: #f8f9fb;
      width: 100%;
      position: relative;
      top: -15px;
      font-size: 12px;
      color: #cccccc;
      border-radius: 0 0 4px 4px;
      line-height: 25px;
    }
  }
  .upload-box {
    /deep/.upload {
      .title {
        display: none;
      }
    }
    .title {
      font-size: 16px;
      color: #1E2226;
      line-height: 14px;
      margin-bottom: 12px;
    }
    /deep/.van-uploader {
      // width: 80px;
      // height: 80px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        background-size: 100% 100%;
        content: "";
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
  }
  .btn {
    background: #36b374;
    border-radius: 4px;
    color: white;
    padding: 0 16px;
    text-align: center;
    font-size: 16px;
    color: white;
    margin-top: 40px;
    line-height: 48px;
  }
  .disable {
    background-color: #9bd9ba;
  }
}
</style>